import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';

export default function DashboardLayout({ children, breadcrumb }) {
  return (
    <div className="min-h-screen bg-white dark:bg-dark-bg">
      <div className="flex">
        <Sidebar />
        <div className="flex-1 flex flex-col min-h-screen">
          <Navbar breadcrumb={breadcrumb} />
          <main className="flex-1 p-6 bg-gray-50 dark:bg-dark-bg-secondary">
            {children}
          </main>
          <Footer variant="default" />
        </div>
      </div>
    </div>
  );
}
